import React from "react";
import Layout from "components/Layout";
import { Box, Text } from "@chakra-ui/react";
import Head from "next/head";

const ResponsibleTaxManagement: React.FC = () => {
  return (
    <Layout>
      <Head>
        <title>101Digital | Responsible Tax Management</title>
      </Head>
      <Text
        as="h1"
        textStyle="h1"
        textAlign={["center", null, null, null, null, "left"]}
        mb={["34px", null, null, null, null, "136px"]}
        mt={["45px", null, null, null, null, "132px"]}
      >
        <Text>
          Responsible Tax Management
        </Text>
      </Text>
      <Box
        maxW="1155px"
        w="100%"
        mb={["34px", null, null, null, null, "99px"]}
        px={["28px", null, null, null, null, "16px"]}
      >
        <Text
          textStyle="paragraph"
          color="primary"
          fontSize={["12px", null, null, null, null, "21px"]}
          fontWeight={300}
        >
          101 Digital PTE is committed to complying with applicable tax laws and
          regulations by paying our fair share of taxes across all countries in
          which we operate. These include all taxes that we incur, as well as
          tax that we collect from our customers, such as witholding taxes. Our
          key principles in relation to tax management are:
          <br />
          <br />
          1. We maintain an open and transparent relationship with tax
          authorities based on trust & respect.
          <br />
          2. We only undertake transactions which are strictly associated with
          genuine commercial activities.
        </Text>
      </Box>
    </Layout>
  );
};

export default ResponsibleTaxManagement;
